<template>
    <!-- style="max-width: 1100px; margin: auto; font-size: 1.5rem;" -->
  <div style="margin: auto; font-size: 1.5rem;" class="grey lighten-3" >
  <v-app>

    <v-flex xs12>
    <v-toolbar color="pink" dark >

      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
      <v-toolbar-title><router-link to="/">RESUME</router-link> <router-link to="/"><small>https://i.ch2n.com/#/en</small></router-link></v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn> -->
    </v-toolbar>
    </v-flex>

    <v-card>
      <v-container fluid grid-list-lg >

        <v-layout row wrap>

          <v-flex >

            <v-card color="blue-grey darken-2" class="white--text">

              <v-layout row style="word-break: break-word;">

                <v-flex >
                  <v-card-title primary-title>
                    <div>
                      <div class="title font-weight-medium mb-1" >Carlos Chen</div>
                      <div>10 years experience</div>
                      <div>i@ch2n.com</div>
                      <div>+86-131-2287-9925</div>
                    </div>
                  </v-card-title>
                </v-flex>

                <!-- <v-flex xs3></v-flex> -->

                    <!-- src="https://i.loli.net/2020/05/31/NCe6DnU2xoQa4dY.jpg" -->
                <v-contianer align-end>
                <v-flex mt-1 mr-2>
                  <v-img
                  class="align-end mt-2"
                    src="../assets/Untitled.png"
                    height="145px"
                    width="145px"
                    contain
                  ></v-img>
                </v-flex>
                </v-contianer>

              </v-layout>

              <v-divider light></v-divider>

              <v-card-actions class="pa-3">
                <v-layout row>
                  <v-flex>
                    <div>Consistently delivered top-tier performance, looking for a position of AgentEngineer/AIOps/DevOps/SRE.</div>
                  </v-flex>
                  <!-- <v-flex class="xs5">
                    <div>Shanghai Polytechnic University</div>
                  </v-flex> -->
                  <!-- <v-flex class="xs4">
                    <div>majored in Electronic Commerce</div>
                  </v-flex> -->
                </v-layout>
              </v-card-actions>

            </v-card>
          </v-flex>


          <v-flex xs12>
            <v-card  style="word-break: break-word;">
            
              <v-card-title primary-title>
                <div style="line-height: 1.25 !important">

                <v-flex class="mb-0 pb-0 mt-0 pt-0">
                  <h3 class="headline mb-0 pb-0 blue--text">Tech Stack Overview</h3>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                    - Linux: </span> Capable of building a minimal Linux distribution following the <a class="blue-grey--text text--lighten-1" href="https://www.linuxfromscratch.org/" target="_blank">Linux From Scratch</a> project.
                      However, I haven't conducted in-depth research into kernel subsystems and eBPF. Efficient terminal operations and proficient bash scripting skills.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - Programming: </span> Prefer async iterators and full type annotations in Python, unfamiliar with metaprogramming. Beginner-level Rust (less than 10k lines of code written), capable only of vibe coding to create <a class="blue--text text--darken-1" href="https://github.com/carlos-chen-tb/awsconnect" target="_blank">daily used tools</a>.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - Kubernetes/Cloud:</span> Multiple years of production experience with k8s/Istio. Proficient with AWS EC2/Lambda/ECS/EKS and supporting services like AppConfig, CloudTrail, CloudFormation, CloudWatch, CostAnomaly, TrustHub... IaC preference: atomized terragrunt with external terraform modules.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - Splunk Expert: </span> Capable of building clusters from scratch, proficient in component configuration, developing extension apps, creating interactive dashboards, and writing <a class="blue--text text--darken-1" href="https://gitee.com/x2c/tmp/blob/main/splunk/query_tips.md" target="_blank">efficient and precise queries</a> for error tracking and impact assessment.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - AI/LLM:</span> Basic understanding of Transformer, CoT/ToT, Tool Calling/ReAct, MCP, RAG, Context/Harness Engineering. Currently exploring two directions: making engineering experience agents reusable over the long term, and building agent self-improvement iterative workflows.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - Exceptional Troubleshooting:</span> User behavior layer (billion-scale environments), network layer (DNS, IP/TCP, TLS, mTLS, certificates, HTTP, Istio, containers, gRPC), service dependencies, codebase, CI/CD, infrastructure-as-code, and configuration-as-code. Capable of quick problem identification and resolution with accurate explanations, allowing more time for design and coding.
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold green--text text--lighten-1" style="font-size: 1.6rem;">
                  - Keep Energy:</span> Completed two half-marathons in 2025 (both under 2 hours). Badminton skill progressed from beginner to intermediate level (80th percentile in casual courts).
                  </div>
                </v-flex>

                <v-flex>
                  <div class="mb-0"> <span class="font-weight-bold blue-grey--text text--lighten-2" style="font-size: 1.6rem;">
                   - My Limitations:</span> <a class="blue-grey--text text--lighten-1" href="https://cert.efset.org/yY3Goy" target="_blank">Intermediate English (B2)</a>. Tendency to invest significant effort in root cause analysis and principles exploration.
                  </div>
                </v-flex>

                </div>
              </v-card-title>
            </v-card>
          </v-flex>


          <v-flex xs12>
            <v-card style="word-break: break-word;">
              <v-card-title primary-title body-2>

                <div style="line-height: 1.25 !important">

                <v-flex class="mb-1 pb-0 mt-0 pt-0">
                  <h3 class="headline mb-0 pb-0 blue--text">Experiences</h3>
                </v-flex>

                <v-flex>
                  <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4" style="font-size: 1.6rem;">DevSecOps Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://www.thirdbridge.com/" target="_blank">Third Bridge</a> 2024.09 - </span>
                  </div>
                  <ul>
                    <li class="mb-2">
                    <div class="mb-1">
                      Broad scope and elevated permissions, primarily working on CI/CD, IaC, Observability, with minor involvement in FinOps and Security.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Ranked in the <span class="font-weight-bold">top three contributors</span> to the GitHub Org annually (1,800 commits, 500+ PRs, 15% of code reviews), paid down substantial technical debt, delivered significant developer experience improvements, and achieved cost optimization.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Identified and fixed a multi-year S3 VPC endpoint binding misconfiguration causing excessive NAT Gateway traffic costs, saving over $80,000 annually.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Eliminated unnecessary docker_layer_caching in the IaC pipeline that had persisted for years, saving over $9,606 annually for this single repo, and extended the optimization across other repositories.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Resolved logic bugs in the serverless pipeline, saving over $2,087 annually. Additional cost reductions include AMI cleanup (~$600/month) and CloudWatch Dashboard cleanup (~$600/month).
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Reduced a Node.js service build pipeline duration from 20 minutes to 3 minutes and templatized these optimizations (CircleCI orb jobs and commands) for reuse across other services.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Templatized all common CI/CD pipeline components to improve overall efficiency and quality, reduce maintenance costs, and eliminate duplication—from individual steps like environment switching and authentication to complete jobs like language-specific build processes.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Built Splunk instance to ingest CircleCI metrics to precisely identify pipeline resource misuse, such as chained triggers with long-running processes that fail silently. Used trigger frequency, failure rates, and average duration metrics to guide optimization efforts.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Designed a reusable CloudWatch Metric Alarm framework (SNS + Lambda + Slack + Terragrunt alarm definitions), enabling new services to quickly define and extend alarms with timely notifications of service disruptions.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Security: Identified oversized attack surface in pipeline OIDC role, systematically fixed permission grants in foundational components, and promoted fine-grained permission roles across the organization.
                    </div>
                    </li>
                  </ul>
                </v-flex>

                <v-flex>
                  <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4" style="font-size: 1.6rem;">Site Reliability Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://www.quest-global.com/" target="_blank">Apple Pay (AWF)</a> 2022.12 - 2024.09</span>
                  </div>
                  <ul>
                    <li class="mb-2">
                    <div class="mb-1">
                      Contractor with Apple Pay APAC SRE team (employed by Quest Global), working in a world-class environment with exceptional user scale and engineering quality standards.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      <span class="font-weight-bold">Tracked complex user behavior at massive scale</span>, primarily leveraging advanced Splunk query techniques to successfully identify subtle business errors multiple times, preventing significant revenue loss.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Resolve prod (and lower env) issues across all layers by leveraging deep understanding of the relevant codebase and architecture: multi-cluster Kubernetes environments, cross-cluster and partner mTLS communication, Istio-based canary deployments and traffic management, Helm-based custom CI/CD pipelines, properties/configuration-as-code, Splunk-based logging, and Prometheus-based observability. Managed typical Deployments and also handled Apache Spark CRDs.
                    </div>
                    </li>
                    <li class="mb-2">
                    <div class="mb-1">
                      Developed scripts to analyze and process data from various internal systems, primarily to resolve production incidents, and occasionally created tooling (CI/CD integrations, local utilities).
                    </div>
                    </li>
                  </ul>
                </v-flex>

                <v-flex >
                    <div class="mb-2">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb1" style="font-size: 1.6rem;">Site Reliability Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://stubhub.com" target="_blank">Stubhub Shanghai Imformation Technology Ltd</a> 2020.8 - 2022.8</span>
                    </div>

                    <ul>
                      <li class="mb-2">
                    <div class="mb-1">As a result of separation from the parent company, eBay, we need to migrate all services from eBay's DC to GCP.
                      I own the Splunk service, have seamlessly <span class="font-weight-bold">transitioned the Splunk cluster to GKE</span>,
                      furnishing the entire organization with logging, alerting, and dashbord capabilities.
                      The daily data volume peaks at a maximum of 5TB.  Containerized all Splunk components (deployer, indexer, search head, license manager, GCP pub/sub extension…), subnet connectivity, data governance and persistence, configuration changes and deployment.
                      </div>
                      </li>

                      <li class="mb-2">
                        <div class="mb-1">
                          Also help to maintain many other internal systems, and implement integrations. 3k+ hosts (vCenter -> GCP -> Azure), inherit from eBay technology architecture (Akamai, stage/dev/prod/wall garden env, 3 pods + F5 VIP, puppet/terraform/ansible/jenkins/nexus/self-hosted yum repo/self-built CICD platform, nginx + stateless spring boot + react + spring batch + oracle + kafka + solr + nfs, Jira, Slack, NewRelic, PagerDuty)
                        </div>
                      </li>
                    </ul>
                </v-flex>

                <v-flex >
                    <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb1" style="font-size: 1.6rem;">
                      Operations Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="https://techown.com" target="_blank">Shanghai Techown Imformation Technology Ltd</a> 2019.4 - 2020.8</span>
                    </div>

                    <ul>
                      <li class="mb-2">
                    <div class="mb-1">To address the pain points of inefficient data processing and alerting gaps, I built a Splunk cluster from ground up,  
                        <span class="font-weight-bold">created over 30 interactive dashboards and many alerts to report key business metrics, 
                        developed a third-party app for DingDing alert,
                        authored several scripts and long-running processes</span> to feed customer needs and optimizing the entire data processing workflow.
                    </div>
                      </li>

                    <li class="mb-1">
                      <div class="mb-1">
                        Here's <span class="font-weight-bold">a slides</span> to describe the overall process: <a class="blue--text text--darken-1" href="https://gitee.com/x2c/tmp/blob/main/slides/A_slide.key" target="_blank">https://gitee.com/x2c/tmp/blob/main/slides/A_slide.key</a>
                      </div>
                    </li>

                      <li class="mb-1">
                      <div class="mb-1">
                        Here's <span class="font-weight-bold">a sample dashboard</span> I made: <a class="blue--text text--darken-1" href="https://i.loli.net/2020/07/13/1sqizeWZkE35cFB.png" target="_blank">https://i.loli.net/2020/07/13/1sqizeWZkE35cFB.png</a>
                      </div>
                      </li>
                    </ul>
                </v-flex>

                <v-flex >
                    <div class="mb-1">
                    <span class="font-weight-bold deep-purple--text text--darken-4 mb5" style="font-size: 1.6rem;">
                      Operations Engineer <a class="font-weight-bold blue-grey--text text--darken-2" href="http://www.houhao.cn" target="_blank">several modestly sized companies</a> 2016.3 - 2019.4</span>
                    </div>

                    <ul>
                      <li class="mb-2">
                    <div class="mb-1">
                      During the initial three years of my career, I consistently operated independently within several modestly sized companies.
                        Most of those jobs are in traditional Ops engineer's scope, including hosts and services management. Highlighted below are <span class="font-weight-bold">some major achievements</span>.
                    </div>

                      </li>

                      <li class="mb-2">
                    <div class="mb-1">
                      For a SaaS web product, achieved a <span class="font-weight-bold">30% cost reduction</span> in AlibabaCloud by moving services to docker and run in less VMs,
                        including nodejs, redis, mongo, mysql, java, and .Net services.
                        Also <span class="font-weight-bold">introduced HA capability</span> into production: 
                        nginx+keepalived LB, keepalived + redis(master slave+sentinel), mongo(replica set), mysql(dual master),
                        migrate deployment runbook from mannully to shell to ansible to docker.
                    </div>

                      </li>

                      <li class="mb-1">
                    <div class="mb-1">
                      For a startup, <span class="font-weight-bold">established the entire office IT infrastructure from zero, encompassing both hardware and software</span>.
                        Managed the procurement and configuration of Router, Switch, Server, Server Rack, Telephonic Switching System, Landline Telephone, and Laptops.
                        Design network, <span class="font-weight-bold">setup Windows Domain</span> with Domain Controller, WDS+MDT, CIFS, WSUS, CA, and VPN.
                        <span class="font-weight-bold">Configure pfSense</span> to govern the network for servers in the IDC, 
                        established site-to-site OpenVPN links to the office network, <span class="font-weight-bold">implemented Zabbix</span> for comprehensive OS and hardware monitoring.
                    </div>
                    </li>
                    </ul>

                </v-flex>
              
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card color="cyan darken-2" class="white--text ">
              <v-card-title primary-title body-2>
                <div class="d-flex headline mb-1">Education</div>
                <div>
                      <div class="mb-1"> - 2012 - 2016, Shanghai Polytechnic University, majored in Electronic Commerce</div>
                      <div class="mb-1"> - The majority of courses are about constructing e-commerce website utilizing Java,
                        employing somewhat outdated technologies such as Java 1.6, Spring MVC, Struts2, and Hibernate.</div>
                      <div class="mb-1"> - I possess a keen interest in exploring those <span class="font-weight-bold text--darken-2">dummy hack stuffs</span>, 
                        such as building minimal Windows images under 100MB, utilizing Linux desktop including Kali, 
                        constructing minimal Android ROMs with only several startup processes, and engaging in iOS jailbreaking.
                      </div>
                </div>
              </v-card-title>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                <div>
                  Appreciate your time to review this resume, an online version is also avaliable in <a href="https://i.ch2n.com/#/en">https://i.ch2n.com/#/en</a>
                </div>
                <v-spacer></v-spacer>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
                <v-icon>star_border</v-icon>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>

      </v-container>
    </v-card>

  </v-app>
  </div>
</template>

<script>
export default {
  name: 'En',
  components: {
  }
}
</script>

<style scoped>
a {
  color: #424242;
}
body {
    /*en,zh,mac,windows,linux,ios,android*/
    font: 14px/1.5 Arial,Helvetica,"Lucida Grande","Helvetica Neue",'PingFang SC',"Hiragino Sans GB","Hiragino Sans GB W3","Microsoft YaHei","WenQuanYi Microhei","Heiti SC","STHeiti","Noto Sans CJK SC","Source Han Sans CN",sans-serif; 
}
</style>
